module.exports = __webpack_public_path__ + "img/play.0b3a9f61.png";